import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SidebarNavDockSpacer } from "@nxt-shared/ui/components/SidebarNav";
import { UserSidebarNav } from "../../components/layout/UserSidebarNav";
import { PAGE_BACKDROP } from "../../components/layout/pageBackdrop";

/** The pages about the signed-in user (Profile, Account, Author profiles), with the sidebar. The `/me` home
 *  is not one of them: it is the launcher into the user's Organizations. */
export const Route = createFileRoute('/me/_settings')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex flex-1 min-h-0 flex-row">
      <UserSidebarNav />
      <div className={`flex-1 min-w-0 max-h-full overflow-y-auto relative lg:border-l bg-gray-50 ${PAGE_BACKDROP}`}>
        <Outlet />
        <SidebarNavDockSpacer />
      </div>
    </div>
  );
}
